module.exports = __webpack_public_path__ + "guide_games.png";